import { Apple, Smartphone } from 'lucide-react';

export function DownloadCTA() {
  return (
    <section className="py-20 bg-transparent">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-poppins text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Ready to{' '}
          <span className="text-locale-primary">rediscover</span> your community?
        </h2>
        <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto">
          Download Locale today and start exploring the vibrant world right outside your door. 
          Connect with neighbors, discover local gems, and support the businesses that make your community special.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {/* App Store Button */}
          <a
            href="#"
            className="group bg-gray-900 hover:bg-gray-800 text-white rounded-xl px-6 py-4 flex items-center gap-3 transition-all duration-300 hover:scale-105 hover:shadow-lg min-w-[200px]"
          >
            <Apple className="w-8 h-8" />
            <div className="text-left">
              <p className="text-xs text-gray-300">Download on the</p>
              <p className="font-poppins font-semibold text-lg leading-tight">App Store</p>
            </div>
          </a>
          
          {/* Android — Google Play button removed until Android ships */}
          <div
            className="bg-gray-100 text-gray-500 rounded-xl px-6 py-4 flex items-center gap-3 min-w-[200px] cursor-default select-none border border-gray-200"
            aria-disabled="true"
          >
            <Smartphone className="w-8 h-8" />
            <div className="text-left">
              <p className="text-xs text-gray-400">Android</p>
              <p className="font-poppins font-semibold text-lg leading-tight">Coming soon</p>
            </div>
          </div>
        </div>
        
        <p className="text-sm text-gray-500 mt-8">
          Available on iOS &middot; Android coming soon
        </p>
      </div>
    </section>
  );
}